<template>
    <el-dialog v-dialogDrag class="selDialog" width="1000px"
               :visible.sync="dialogVisible"
               append-to-body
               @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                物资成本价格选择
            </div>
        </div>
        <div class="dialog_body">
            <el-table
                    ref="treeTable"
                    :data="dataList"
                    height="400"
                    style="width: 100%;"
                    highlight-current-row
                    :header-cell-style="headerStyle"
                    :cell-style="cellStyle"
                    @row-click="rowClick"
                    row-key="id"
                    border>
                <el-table-column
                        prop="typeName"
                        label="物资类别">
                </el-table-column>
                <el-table-column
                        prop="proCode"
                        label="物资编码"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="proName"
                        label="物资名称">
                </el-table-column>
                <el-table-column
                        prop="units"
                        width="150"
                        label="计量单位">
                </el-table-column>
                <el-table-column
                        prop="specification"
                        width="150"
                        label="规格型号">
                </el-table-column>
                <el-table-column
                        prop="costPrice01"
                        width="150"
                        label="成本价">
                </el-table-column>
            </el-table>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        name: "selRole",
        props: ['productInfoId'],
        components:{},
        data() {
            return {
                dialogVisible: true,
                dialoading: false,
                dataList: [],
            }
        },
        async mounted() {
            await this.getListData();
        },
        methods: {
            headerStyle() {
                return "text-align:center;height:45px;line-hight:45px;padding: 1px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            async search(){
                await this.getListData();
            },
            async getListData() {
                this.dialoading = true;
                let param = {
                    url: "/productinfo/listCostPriceSel",
                    param: {
                        productInfoId:this.productInfoId
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == '0') {
                    this.dataList = data.data.data;
                }
                this.dialoading = false;
            },
            selRow(row){
                this.$emit("checkRow",row);
            },
            rowClick(row){
                this.$emit("checkRow",row);
            },
        },
    }
</script>

